import * as React from 'react';
import * as style from './ConvertSharesStyle.module.scss'
import * as elemsStyle from '@appStyles/_elements.module.scss';
import IConvertShares from './IConvertShares';
import ISPVsAsset from '@market/interfaces/ISPVsAsset';
import Big from 'big.js';
import InfoBox from '@appComponents/InfoBox/InfoBox';
import { numberWithDelimiter } from '@features/utils/functions';


const ConvertShares: React.SFC<IConvertShares> = (props) => {
  const setCheckbox = () => {
    props.setCheckbox({ convertShares: !props.value });
  };

  const getAssetsShares = () => {
    return props.assets.reduce((acc: number, curr: ISPVsAsset) => {
      return Number(new Big(acc).add(curr.sellable_number_of_shares));
    }, 0);
  };

  const { share_type, sellable_number_of_shares }
    = props.assets.find((el: ISPVsAsset) => el.trading)!;
  const nonTradableClasses: string[] = [];
  props.assets.forEach((el) => {
    if (el.share_type !== share_type && !nonTradableClasses.includes(el.share_type.toUpperCase())) {
      nonTradableClasses.push(el.share_type.toUpperCase());
    }
  });

  const nonTradingShares = numberWithDelimiter(Number(new Big(getAssetsShares()).minus(sellable_number_of_shares)));
  const tradingLabel = share_type === 'a' ? `full-voting A shares` : `non-voting B shares`;
  const nonTradinglabel =
    `${share_type === 'a' ? 'non-voting ' : 'full-voting '}${nonTradableClasses.join(', ')} shares`;

  return (
    <InfoBox headline={`Before you place sell ${props.type}`}>
      <div className={style.convertShares}>
        <p>
          {`Only '${tradingLabel}' can be sold on our secondary market. You do not hold sufficient number of
          '${tradingLabel}' to complete this action yet. In order to proceed, you will be required to convert your
          ${nonTradingShares} '${nonTradinglabel}' to '${tradingLabel}' (the tradable type). Please be aware this action
          will change some attributes of your holding (such as voting right) and is irreversible.`}
        </p>
        <div className={style.holdings}>
          <p>
            Current {share_type.toUpperCase()} type holding:
            <strong> {numberWithDelimiter(sellable_number_of_shares)}</strong>
          </p>
          <p>Current {nonTradableClasses.join(', ')} type holding: <strong>{nonTradingShares}</strong></p>
        </div>
        <div className={[elemsStyle.customCheckbox, style.customCheckbox].join(' ')}>
          <input
            type="checkbox"
            id="convert-shares"
            onChange={setCheckbox}
            checked={props.value}
          />
          <label htmlFor="convert-shares">
            Yes, I want to convert my shares
          </label>
        </div>
      </div>
    </InfoBox>
  );
};

export default ConvertShares;
